// Seems like dead code

import React from 'react';
import { connect } from 'react-redux';
import DeleteGroupContent from '../components/pages/group/delete/content';

@connect(mapStateToProps)
export default class DeleteGroupPage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <DeleteGroupContent groupForm={this.props.groupForm} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    groupForm: state.groupsReducer.groupForm,
  };
}
